"use client";

import { useState } from "react";
import Avatar from "rivals/components/shared/Avatar";
import CustomButton from "rivals/components/shared/CustomButton";
import XLogoIcon from "rivals/components/shared/Icons/XLogoIcon";
import { PATHS } from "rivals/shared/constants";
import { isArticleAuthorType } from "rivals/shared/interfaces/Author";
import { setData } from "rivals/shared/utils/qa";
import styles from "./Author.module.scss";
import type { Props } from "./types";

const DATA_PHILTER = "author";

function Author({ authorInfo }: Props): JSX.Element {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const {
    siteTitle,
    imageUrl,
    publisherName,
    twitterHandle,
    siteName
  } = authorInfo;
  const toggleIsDrawerOpen = (): void => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const sameLineDivider = <>&nbsp;•&nbsp;</>;

  const drawerIcon = isDrawerOpen
    ? "/static/icons/chevron-up.svg"
    : "/static/icons/chevron-down.svg";

  let url;

  if (isArticleAuthorType(authorInfo)) {
    url = imageUrl ?? undefined;
  }

  return (
    <div className={styles.container}>
      <div className={styles.authorInfo}>
        <div className={styles.authorContainer}>
          {url && (
            <Avatar
              {...setData(DATA_PHILTER, "image-profile")}
              alt={""}
              className={styles.authorImage}
              mobileSize={54}
              size={60}
              url={url}
            />
          )}
          <div className={styles.authorName}>
            {publisherName && (
              <div {...setData(DATA_PHILTER, "name")}>
                {publisherName} {siteName && sameLineDivider} {siteName}
              </div>
            )}
            <div
              className={styles.authorTitle}
              {...setData(DATA_PHILTER, "job-title")}
            >
              {siteTitle}
            </div>
            {twitterHandle && (
              <a
                className={styles.twitterHandle}
                href={`${PATHS.X_URL}${twitterHandle}`}
                rel="noreferrer"
                target="_blank"
              >
                <XLogoIcon
                  fill={"black"}
                  style={{ height: "20px", width: "20px" }}
                />
                <div>@{twitterHandle}</div>
              </a>
            )}
          </div>
        </div>
        {authorInfo.bio && (
          <CustomButton
            buttonText={""}
            className={styles.authorBioDrawer}
            icon={<img alt={""} src={drawerIcon} />}
            onClick={toggleIsDrawerOpen}
          />
        )}
      </div>
      {isDrawerOpen && (
        <div {...setData(DATA_PHILTER, "bio")} className={styles.authorBio}>
          {authorInfo.bio}
        </div>
      )}
    </div>
  );
}

export default Author;
